import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/ri07y6ac_WhatsApp%20Image%202026-02-10%20at%2015.11.53.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/productos', label: 'Productos' },
    { path: '/servicio-obra', label: 'Servicio a Obra' },
    { path: '/sobre-nosotros', label: 'Sobre Nosotros' },
    { path: '/formacion', label: 'Formación' },
    { path: '/blog', label: 'Blog' },
    { path: '/contacto', label: 'Contacto' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50" data-testid="header">
      {/* Top Bar */}
      <div className="bg-[#1A365D] text-white py-2">
        <div className="section-container flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a 
              href="tel:858130213" 
              className="flex items-center gap-2 hover:text-blue-200 transition-colors"
              data-testid="header-phone-link"
            >
              <Phone className="w-4 h-4" />
              <span className="hidden sm:inline">858 130 213</span>
            </a>
            <a 
              href="https://www.google.com/maps/place/Fornes+e+Hijos/@36.7275346,-3.5402629,17z" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-blue-200 transition-colors"
              data-testid="header-location-link"
            >
              <MapPin className="w-4 h-4" />
              <span className="hidden md:inline">Polígono Alborán, Motril</span>
            </a>
          </div>
          <div className="text-xs sm:text-sm">
            <span>L-V: 07:30-13:30 / 15:30-18:00</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="section-container py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Fornes e Hijos - Yesos y Pladur Motril" 
              className="h-14 sm:h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-heading text-lg font-semibold transition-colors ${
                  isActive(link.path)
                    ? 'text-[#3182CE]'
                    : 'text-[#2D3748] hover:text-[#3182CE]'
                }`}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:858130213"
              className="btn-primary flex items-center gap-2 cta-btn"
              data-testid="header-cta-call"
            >
              <Phone className="w-5 h-5" />
              Llamar Ahora
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-[#2D3748]"
            aria-label="Menú"
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4 mobile-menu-enter" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-heading text-lg font-semibold py-2 ${
                    isActive(link.path)
                      ? 'text-[#3182CE]'
                      : 'text-[#2D3748]'
                  }`}
                  data-testid={`mobile-nav-link-${link.path.replace('/', '') || 'home'}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:858130213"
                className="btn-primary flex items-center justify-center gap-2 mt-4"
                data-testid="mobile-cta-call"
              >
                <Phone className="w-5 h-5" />
                Llamar Ahora
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
